import { render, staticRenderFns } from "./SAutocompleteOption.vue?vue&type=template&id=34fa7f7b&scoped=true&"
import script from "./SAutocompleteOption.vue?vue&type=script&lang=ts&"
export * from "./SAutocompleteOption.vue?vue&type=script&lang=ts&"
import style0 from "./SAutocompleteOption.vue?vue&type=style&index=0&id=34fa7f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa7f7b",
  null
  
)

export default component.exports